import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=9970713a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9970713a"]])

export default __exports__